import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useAnalyses } from '../../lib/hooks';
import { auth } from '../../lib/firebase';
import { AnalysisModal } from './AnalysisModal';
import { AnalysisList } from './AnalysisList';

interface AnalysisPageProps {
  onKnowledgeClick?: () => void;
}

export function AnalysisPage({ onKnowledgeClick }: AnalysisPageProps) {
  const [showNewAnalysis, setShowNewAnalysis] = useState(false);
  const { analyses, loading } = useAnalyses(auth.currentUser?.uid);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-amber-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6 mt-4">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl text-white font-brand font-light italic">Bread Analysis</h1>
          <button
            onClick={() => setShowNewAnalysis(true)}
            className="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-amber-500/90 to-amber-600/90 hover:from-amber-400 hover:to-amber-600 text-white rounded-xl disabled:opacity-50 transition-all duration-300"
          >
            NEW ANALYSIS
          </button>
        </div>
        <p className="text-sm text-white mt-1">
          Get useful feedback on your results and improve your baking skills.
        </p>
      </div>

      <AnalysisList
        analyses={analyses}
        onKnowledgeClick={onKnowledgeClick}
        onCreateAnalysis={() => setShowNewAnalysis(true)}
      />

      <AnalysisModal
        isOpen={showNewAnalysis}
        onClose={() => setShowNewAnalysis(false)}
        onKnowledgeClick={onKnowledgeClick}
      />
    </div>
  );
}